"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrefiterParams = void 0;
const react_router_dom_1 = require("react-router-dom");
const helpers_1 = require("../helpers");
const useSearchParams_1 = require("./useSearchParams");
const usePrefiterParams = () => {
    const { search } = (0, react_router_dom_1.useLocation)();
    const { clearSearchParams } = (0, useSearchParams_1.useSearchParams)();
    const PREFILTERS_STORAGE_KEY = 'pergamum-prefilters';
    const initPrefilters = () => {
        const currentParams = getAll();
        const parsedQuery = new URLSearchParams(search);
        let newParams = {
            id: null,
            id_biblioteca: null,
            cr: null,
            id_colecao: null,
            tipo_obra: null,
        };
        if (parsedQuery.has('id'))
            newParams.id = parsedQuery.get('id');
        if (parsedQuery.has('id_biblioteca'))
            newParams.id_biblioteca = helpers_1.StringHelper.getWithCommaAtTheEnd(parsedQuery.get('id_biblioteca'));
        if (parsedQuery.has('cr'))
            newParams.cr = parsedQuery.get('cr');
        if (parsedQuery.has('id_colecao'))
            newParams.id_colecao = helpers_1.StringHelper.getWithCommaAtTheEnd(parsedQuery.get('id_colecao'));
        if (parsedQuery.has('tipo_obra'))
            newParams.tipo_obra = helpers_1.StringHelper.getWithCommaAtTheEnd(parsedQuery.get('tipo_obra'));
        if (!helpers_1.ObjectHelper.areAllFieldsNull(newParams) &&
            !helpers_1.ObjectHelper.compareObjects(newParams, currentParams))
            localStorage.setItem(PREFILTERS_STORAGE_KEY, JSON.stringify(newParams));
        parsedQuery.delete('id');
        parsedQuery.delete('id_biblioteca');
        parsedQuery.delete('cr');
        parsedQuery.delete('id_colecao');
        parsedQuery.delete('tipo_obra');
        clearSearchParams(parsedQuery);
    };
    const getAll = () => {
        let params = {
            id: null,
            id_biblioteca: null,
            cr: null,
            id_colecao: null,
            tipo_obra: null,
        };
        const fromStorageRaw = localStorage.getItem(PREFILTERS_STORAGE_KEY);
        if (fromStorageRaw)
            params = JSON.parse(fromStorageRaw);
        if (params)
            Object.keys(params).forEach((key) => {
                // @ts-ignore
                if (typeof params[key] === 'string') {
                    // @ts-ignore
                    params[key] = decodeURIComponent(params[key]);
                }
            });
        return params;
    };
    const remove = (key) => {
        const all = getAll();
        all[key] = null;
        localStorage.setItem(PREFILTERS_STORAGE_KEY, JSON.stringify(all));
    };
    const clear = () => {
        localStorage.removeItem(PREFILTERS_STORAGE_KEY);
    };
    return { initPrefilters, getAll, remove, clear };
};
exports.usePrefiterParams = usePrefiterParams;
